import { permalinkFeature } from "./datepicker";
import { itineraryEntriesData } from "./source";

export const countries = []

export function loadCountries(lang, countries) {


    let selectHTMLenStart = ''



    let selectHTMLenMiddle = ''

    if (lang == 'en') {
        countries.sort(function (a, b) {
            if (a.nameEN < b.nameEN) return -1;
            if (a.nameEN > b.nameEN) return 1;
            return 0;
        })
        selectHTMLenStart += '<div><label class="form-check-label countriesLabel" for="selectCountries">Select countries</label></div>' +
            '<div class="input-group rounded" style="position: relative; right: -2em;">' +
            '<button class="btn btn-outline-secondary dropdown-toggle"' +
            'data-bs-auto-close="outside" id="selectCountries" type="button" data-bs-toggle="dropdown"' +
            'aria-expanded="false">countries</button>' +
            '<ul class="dropdown-menu countriesDropdown">'

        for (var i = 0; i < countries.length; i++) {
            selectHTMLenMiddle = selectHTMLenMiddle + '<li><input class="form-check-input" type="checkbox" value="' +
                countries[i].nameEN + '" id="' + countries[i].countryID + '" name="' + countries[i].namePL + '" />' + '\n' +
                '<label class="form-check-label" for="' + countries[i].nameEN + '">' + countries[i].nameEN + '</label>' +
                '</li>'
        }
    } else {
        countries.sort(function (a, b) {
            if (a.namePL < b.namePL) return -1;
            if (a.namePL > b.namePL) return 1;
            return 0;
        })

        selectHTMLenStart += '<div><label class="form-check-label countriesLabel" for="selectCountries">Wybierz kraje</label></div>' +
            '<div class="input-group rounded" style="position: relative; right: -2em;">' +
            '<button class="btn btn-outline-secondary dropdown-toggle"' +
            'data-bs-auto-close="outside" id="selectCountries" type="button" data-bs-toggle="dropdown"' +
            'aria-expanded="false">kraje</button>' +
            '<ul class="dropdown-menu countriesDropdown">'

        for (var i = 0; i < countries.length; i++) {
            selectHTMLenMiddle = selectHTMLenMiddle + '<li><input class="form-check-input" type="checkbox" value="' +
                countries[i].namePL + '" id="' + countries[i].countryID + '" name="' + countries[i].namePL + '" />' + '\n' +
                '<label class="form-check-label" for="' + countries[i].nameEN + '">' + countries[i].namePL + '</label>' +
                '</li>'
        }

    }





    let selectHTMLenEnd = '</ul></div>'
    $('#filterCountries').html(selectHTMLenStart + selectHTMLenMiddle + selectHTMLenEnd)

}

itineraryEntriesData.on('featuresloadend', function () {

    itineraryEntriesData.getFeatures().forEach(function (f) {

        if (!countries.some(e => e.countryID == f.values_.IDCountry)) {
            countries.push({
                countryID: f.values_.IDCountry,
                namePL: f.values_.Country_pl_name,
                nameEN: f.values_.Country_eng_name,
            });
        }
    });
    if (permalinkFeature.getUrlParam('lang') == 'pl')
        loadCountries('pl', countries)
    else
        loadCountries('en', countries)

});

